import { createStepsStore } from "@/src/stores/createStepsStore";
import { useSubscribe } from "@/src/lib/actions";
import { useState } from "react";

export const useStepsStore = createStepsStore(["Customer", "Description", "Yachts", "Summary", "Preview"] as const);


/** The three visible builder steps (prototype: Choose / Configure & message /
 * Preview & send). "Customer" and "Description" remain valid step VALUES —
 * they now render as dialogs over the flow rather than stepper entries, so
 * every existing setStep("Customer"/"Description") call just opens a dialog. */
export const BUILDER_STEPS = ["Yachts", "Summary", "Preview"] as const;
export const BUILDER_STEP_LABELS: Record<string, string> = {
  Yachts: "Choose yachts",
  Summary: "Configure & message",
  Preview: "Preview & send",
};

export function usePageSize() {
  const [pageSize, setPageSize] = useState(40);

  useSubscribe<number>("ych:page-size", setPageSize);

  return pageSize;
}

export function useSorting() {
  const [sorting, setSorting] = useState("priceASC");

  useSubscribe<string>("ych:sorting", setSorting);

  return sorting;
}
